import { useGetNotificationsQuery, useGetUnreadCountQuery } from '../notificationsApi';

export const useNotifications = (params = {}) => {
  return useGetNotificationsQuery(params, {
    selectFromResult: (result) => ({
      notifications: result.data || [],
      isLoading: result.isLoading,
      isError: result.isError,
      error: result.error,
      refetch: result.refetch,
    }),
  });
};

export const useUnreadCount = () => {
  return useGetUnreadCountQuery(undefined, {
    selectFromResult: ({ data, isLoading, isError, error }) => ({
      unreadCount: data || 0,
      isLoading,
      isError,
      error,
    }),
  });
};
